const assets = {
  _conditional: (data) => {
    const { format, apiData } = data;

    let mainVideoBg = null;

    if (format === "1920x1080") {
      mainVideoBg = `mainbackground_1920`;
    }

    if (format === "1200x1500") {
      mainVideoBg = `mainbackground_1200`;
    }

    return [assets[mainVideoBg]];
  },
  mainbackground_1920: require("./videos/Background_12_TOPSCORER_16-9.webm"),
  mainbackground_1200: require("./images/Background_12_TOPSCORER_4-5.png"),
  sap_white: require("../../../assets/logos/sap_white.png"),
  penny_del: require("../../../assets/logos/penny-del-logo-season.png"),
  missing_player: require("./images/missing_player.png"),
};

export default assets;
